export default __webpack_public_path__ + "static/media/0.4204567f.jpg";